import { AxiosPromise } from 'axios'

import api from '@config/api'

export function getAll(): AxiosPromise {
  return api.get('v1/Usuario')
}

export function create(data: any): AxiosPromise {
  return api.post('v1/Usuario', data)
}

export function update(data: any, email: any): AxiosPromise {
  return api.put(`v1/Usuario?email=${email}`, data)
}

export function destroy(id: string | number, _email: any): AxiosPromise {
  return api.delete(`v1/Usuario/${id}`)
}

export function getAllProfiles(): AxiosPromise {
  return api.get('v1/Perfil')
}

export function getUsuariosSap(busca: string, quantidade = 20): AxiosPromise {
  return api.get('v1/Usuario/UsuariosSap', { params: { busca, quantidade } })
}

export default {
  getAll,
  getAllProfiles,
  getUsuariosSap,
  create,
  update,
  destroy
}
